import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-03-29'
        tag='eBay'
        title='How the eBay Refurbished Program Works for Sellers'
      >
        <p>
          As a seller on eBay, you have to be able to find ways to increase your sales and get the most out of your
          listings. The best way to do this is by joining the eBay Refurbished Program. Some of the most popular items
          on the refurbished programs are electronics, where you can find computers and cellphones in excellent
          condition at an affordable price. The program gives the seller and buyer peace of mind since qualified
          technicians inspect all items before being put up for sale.{' '}
        </p>
        <p>
          When you buy refurbished goods from eBay, you know they have been checked over by experts and are as good as
          new! This article will discuss how the eBay refurbished program works for sellers, how to be a qualified
          refurbished seller, and become one of the Power sellers!{' '}
        </p>

        <h3>What is the eBay Refurbished Program?</h3>
        <p>
          Nowadays, many people are looking for ways to save money and conserve the environment. This is why refurbished
          items are in-demand on almost all e-commerce platforms. And one of the leading go-to destinations for shoppers
          looking for refurbished products is eBay.{' '}
        </p>
        <p>
          The eBay Refurbished program allows sellers to sell refurbished items that have been professionally inspected
          and certified by experts. If you are unfamiliar, refurbished items are products that were returned under
          warranty due to defects and are being resold by the manufacturer after reconditioning and ensuring
          functionality.{' '}
        </p>
        <p>
          However, sellers need to qualify and pass the requirements before they can start selling their refurbished
          inventory on eBay. There are different refurbished conditions that a seller can sell on eBay. Experts will
          determine whether the refurbished inventory qualified to be in{' '}
          <strong>Certified, Excellent, Very Good, and Good</strong> conditions. Each type has benefits such as up to 2
          years warranty, a money-back guarantee, and free returns.{' '}
        </p>
        <p>
          Most of the refurbished items are smartphones and computers. EBay Refurbished Program gives buyers assurance
          that their refurbished items are reconditioned directly from the manufacturer, manufacturer-approved
          refurbisher, or eBay vetted sellers.{' '}
        </p>
        <p>
          eBay's strict standards in selling refurbished items instill trust and confidence in its buyer. Consumers can
          make sure they are buying a refurbished item at their expected condition, and sellers are more likely to
          lessen claims under "item not as described."{' '}
        </p>

        <h3>4 Types of Refurbished Conditions</h3>
        <p>
          eBay categorized their refurbished conditions into four types. The{' '}
          <strong>Certified, Excellent, Very Good,</strong> and <strong>Good</strong> Condition. We will break down each
          of these conditions, benefits, and how a seller can qualify in selling them.{' '}
        </p>

        <h3>Certified Refurbished Condition</h3>
        <p>
          A certified refurbished product means that the item is in mint (like-new) condition. It must also come in a
          new packaging along with a new or original manual and accessories. The seller must also provide evidence that
          the item has been professionally inspected, cleaned, and refurbished directly from the manufacturer or a
          manufacturer-approved refurbisher.{' '}
        </p>
        <p>
          eBay will review the qualification requirements first before the seller can use the "certified refurbished"
          condition in their listings. After they pass, they can add it to their listing titles, subtitles, and product
          description.{' '}
        </p>

        <h4>Program Benefits </h4>
        <ul>
          <li>Two years Allstate Warranty</li>
          <li>Free shipping and 30-day free returns</li>
          <li>Your listing will be found under the "Certified Refurbished Condition" on eBay to boost visibility. </li>
          <li>
            Your listings will have the eBay refurbished badge in Search, View Item, Check-out, and Order confirmation
            pages.
          </li>
          <li>More buyers will gain trust and confidence in buying refurbished items in your shop. </li>
        </ul>

        <h3>Criteria to be Certified Refurbished Seller </h3>
        <p>
          Sellers who wish to qualify as certified refurbished sellers must meet and comply with the following program
          requirements:{' '}
        </p>
        <ul>
          <li>
            You must be the manufacturer or a manufacturer-approved vendor with authorization to resell the
            manufacturer's products.{' '}
          </li>
          <li>
            Your account must be in a good standing position, with average or good service level metrics, and follow all
            eBay policies and standards.{' '}
          </li>
          <li>You must be residing in the U.S. </li>
          <li>Your inventory complies with certified refurbished condition requirements: </li>
          <ul>
            <li>The refurbished items must be pristine with few or no visible flaws. </li>
            <li>
              The item must be bought or sourced directly from the manufacturer, with proof of purchase or authorization
              and the manufacturer's warranty.{' '}
            </li>
            <li>The refurbished item must be listed with free shipping and 30-day free returns.</li>
            <li>The refurbished item must come in new packaging with its original or new accessories and manual. </li>
          </ul>
        </ul>
        <p>
          The seller must meet and comply with all the requirements before qualifying to sell certified refurbished
          condition items. In this way, eBay can make sure certified refurbished sellers uphold high seller standards,
          and buyers can buy refurbished items confidently.{' '}
        </p>

        <h3>Becoming a Certified Refurbished Seller </h3>
        <p>
          If you meet and can provide all the needed requirements to become a certified refurbished seller, there are
          two ways to participate in this program.{' '}
        </p>
        <ol>
          <li>
            If you are a U.S.-based seller, simply{' '}
            <a href='https://signin.ebay.com/ws/eBayISAPI.dll?SignIn&UsingSSL=1&siteid=0&co_partnerId=2&pageType=2341853&ru=https%3A%2F%2Fwww.ebay.com%2Fsrv%2Fsurvey%2Fa%2Fselling.sellerrefurbish.us'>
              submit your application
            </a>{' '}
            to participate.{' '}
          </li>
          <li>
            If you are from eBay UK, Canada, or Australia, check their certified refurbished program pages to see how to
            participate.{' '}
          </li>
        </ol>
        <p>
          eBay will contact you within two weeks (for US-based sellers) to notify you whether you qualified for the
          program or still need to improve some metrics.{' '}
        </p>

        <h3>Excellent, Very Good, and Good Refurbished Conditions </h3>
        <p>
          eBay offers a wide variety of refurbished item conditions buyers can choose from. Aside from the certified
          refurbished condition items that can only be given to the manufacturer or manufacturer-approved vendor. eBay
          also lets its vetted sellers sell refurbished items as long as they meet its grading requirements by
          condition.{' '}
        </p>
        <ul>
          <li>Excellent - The item must be in like-new condition with few to minimal visible blemishes</li>
          <li>Very Good - The item shows minimal signs of wear </li>
          <li>Good - The item shows moderate signs of wear</li>
        </ul>
        <p>
          Regardless of their condition, all refurbished items must be fully functional and professionally
          reconditioned. The refurbished items are also expected to come in new packaging with their original or new
          manuals and accessories. The vetted seller must also offer free shipping and 30-days free returns.{' '}
        </p>
        <p>
          eBay will review and check if your listing is qualified to be sold under the Excellent, Very Good, and Good
          refurbished condition program. Once all qualifications are met, you can add this information in your listing
          titles, subtitles, and product descriptions.{' '}
        </p>

        <h4>Program Benefits</h4>
        <ul>
          <li>One year Allstate Warranty</li>
          <li>Free shipping and 30-day free returns </li>
          <li>
            Your listings will be found under eBay's Excellent, Very Good, and Good Conditions refurbished items.{' '}
          </li>
          <li>
            Your listing will have the eBay refurbished badge in Search, View Item, Check out, and order confirmation
            pages.{' '}
          </li>
          <li>
            Your listing will gain more views and attract potential customers looking for fully functional refurbished
            items at an affordable price.{' '}
          </li>
        </ul>

        <h3>Criteria to be an Excellent, Very Good, and Good Refurbished Condition Seller </h3>
        <p>
          Sellers who want to participate in this program must meet a strict set of requirements. This includes the
          following:{' '}
        </p>
        <ul>
          <li>
            Your account must be in good standing, with average or better service level metrics, and comply with all
            eBay policies and standards.{' '}
          </li>
          <li>You must be residing in the U.S. </li>
          <li>You must be an eBay Top Rated Seller.</li>
          <li>Your service metrics must be or above the following: </li>
          <li>98.5% feedback score</li>
          <li>&lt; 0.5% defect rate </li>
          <li>&lt; 5.0% late delivery rate </li>
          <li>&lt; 10.0% return rate </li>
          <li>1-2 days handling time</li>
          <li>You must offer free shipping and 30-days free returns.</li>
          <li>
            Your item must include diagnostic test results that show your refurbished item is fully functional,
            professionally cleaned and tested, and professionally refurbished to a high standard.{' '}
          </li>
          <li>Your refurbished item must come in new packaging with original or new accessories and manuals. </li>
        </ul>
        <p>
          eBay will review your account and qualification. If you have been accepted into the program, eBay will grade
          your item according to its grading criteria condition. If your application has been rejected, but you believe
          your refurbished inventory qualifies, you can re-submit your program application. eBay will usually respond to
          your dispute within 30 days.{' '}
        </p>

        <h3>Seller Refurbished vs. Certified Refurbished</h3>
        <p>
          Many buyers are still confused about the difference between a seller refurbished and a certified refurbished.
          Both of them undergo a strict set of requirements before being listed according to their grading criteria.{' '}
        </p>
        <p>
          The certified refurbished condition means that the manufacturer has refurbished it. On the other hand, seller
          refurbished items mean that the seller has refurbished them through a third-party refurbisher or a retailer
          with an in-house refurbisher team. One example of these is iPhones.{' '}
        </p>
        <p>
          Certified Refurbished iPhones are more expensive than seller Refurbished iPhones because of two things. The
          iPhone has been refurbished by Apple's refurbisher team, with an extended warranty (up to 2 years), and comes
          in new packaging with Apple-branded accessories and manuals.{' '}
        </p>
        <p>
          Meanwhile, seller refurbished iPhones are sold at a more affordable price with a one-year warranty and come in
          new packaging with new accessories and manuals. However, most of the packaging and accessories of the
          refurbished items are unbranded ones.{' '}
        </p>
        <p>
          Before you can list your items as certified refurbished or seller refurbished, your listing must qualify to
          eBay's strict requirements and protocols. This ensures that eBay remains a leading eCommerce platform for
          high-quality refurbished items and meets the consistent standard of buyers' expectations.{' '}
        </p>

        <h3>Do More with OneShop </h3>
        <p>
          While selling refurbished items on eBay can make your listing stand out and help boost your sales, you must
          also optimize and keep your day-to-day operations at bay. Aside from posting your listing, you must take a
          photo, add listing titles and descriptions, share it, or join promotions to help you make a sale.{' '}
        </p>
        <p>
          With everything that comes in reselling business, it's good to have a helping hand. The good news is that
          there is a tool that can help you automate tasks, act as your virtual assistant with human-like activity, and
          have customizable features to help you reach your goals.{' '}
        </p>
        <p>
          This tool is called OneShop. It acts as your marketing expert who can list across multiple online marketplaces
          like Poshmark, Mercari, Depop, and many other eCommerce platforms soon! It can also automate listing tasks
          such as liking, sharing, and following on Poshmark, and relist on Mercari.{' '}
        </p>
        <p>
          You can utilize this tool to save you more time and do other essential things than spend hours doing listing
          tasks manually. Cross-listing to eBay will soon be available on OneShop to help you be one of eBay's
          PowerSellers!{' '}
        </p>
        <p>
          See the difference OneShop makes to your reselling business. Try it yourself,{' '}
          <a href='https://tools.oneshop.com/signup'>register for free</a> and enjoy a 7-day free trial on our exclusive
          seller tool with no credit card information required.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
